import { ReactNode, useState } from 'react';
import arrowDownSprite from './arrow-down-sprite.svg';
import Item from './Item';
import { styles as linkStyles } from './Link';

interface DropdownProps {
  children?: ReactNode;
  text?: ReactNode;
}

function Dropdown({ children, text, ...passThrough }: DropdownProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Item
      isActive={isOpen}
      className={isOpen ? 'active' : ''}
      onMouseEnter={(): void => {
        setIsOpen(true);
      }}
      onMouseLeave={(): void => {
        setIsOpen(false);
      }}
      {...passThrough}
    >
      {(): JSX.Element => (
        <span className={`dropdown ${isOpen ? 'active' : ''} link`}>
          {text}
          <div className={`arrow ${isOpen ? 'active-arrow' : ''}`} />
          {isOpen ? children : null}
          <style jsx>{linkStyles}</style>
          <style jsx>
            {`
              .dropdown {
                padding-right: 16px;
                height: 63px;
                padding-bottom: 10px;
              }

              .arrow {
                position: relative;
                display: inline-block;
                background-image: url(${arrowDownSprite});
                height: 9px;
                width: 15px;
                background-size: 100% auto;
                top: 0px;
                left: 6px;
                background-repeat: no-repeat;
                background-position: 0 0px;
              }

              .active-arrow {
                background-position: 0 -27px;
              }
            `}
          </style>
        </span>
      )}
    </Item>
  );
}

export default Dropdown;
